var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.clickable)?_c('img',{class:_vm.classes,attrs:{"src":_vm.address,"alt":"icon"},on:{"click":_vm.onClickHandler}}):_c('img',{class:_vm.classes,attrs:{"src":_vm.address,"alt":"icon"}})}
var staticRenderFns = []

export { render, staticRenderFns }